import { BooleanInput, Create, FormDataConsumer, SimpleForm, TextInput } from 'react-admin';
import AddToLokaliseButton from '../../Components/AddToLokaliseButton';

const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '{}');
const jsonParse = (value: string) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const RequestSubtypeTemplatesCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="requestTypeTemplateUuid" label="Type Template UUID" required fullWidth />
      <TextInput source="country" label="Country (2-char ISO)" inputProps={{ maxLength: 2 }} required />
      <TextInput source="name" label="Name" required />
      <TextInput source="nameId" label="Name ID" required />
      <TextInput source="translationKey" label="Translation Key" required />
      <FormDataConsumer>{({ formData }) => <AddToLokaliseButton translationKey={formData.translationKey} />}</FormDataConsumer>
      <BooleanInput source="active" label="Active" defaultValue={true} />
      <TextInput source="template" label="Template (JSON)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParse} required />
    </SimpleForm>
  </Create>
);

export default RequestSubtypeTemplatesCreate;
